// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LabeledString from '../../../../shared/components/labeled-string/index';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import {buildDate} from '../../../../shared/services/build-date';

const WarrantyCoverageItemRowTwo = (props, context) =>
    <div className='warranty-coverage-item-row-two'>
        {props.warranty.contractPurchaseDate > 0 &&
            <LabeledString
                className='contract-purchased'
                data={buildDate(props.warranty.contractPurchaseDate, context.user.settings.general.dateFormat.key)}
                label='CONTRACT_PURCHASED'
            />
        }
        {props.warranty.contractTypeIndicator &&
            <LabeledString
                className='contract-type'
                data={props.warranty.contractTypeIndicator}
                label='CONTRACT_TYPE'
            />
        }
        {props.warranty.warrantyBeginMeasurement.reading &&
            <LabeledString
                className='start-amount-of-use'
                data={`${props.warranty.warrantyBeginMeasurement.reading} ${props.warranty.warrantyBeginMeasurement.unit}`}
                label='START_AMOUNT_OF_USE'
            />
        }
    </div>;

WarrantyCoverageItemRowTwo.displayName = 'WarrantyCoverageItemRowTwo';
WarrantyCoverageItemRowTwo.propTypes = {
    warranty: PropTypes.instanceOf(Warranty).isRequired
};
WarrantyCoverageItemRowTwo.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default WarrantyCoverageItemRowTwo;



// WEBPACK FOOTER //
// ./src/product/details/components/warranty-coverage-panel/warranty-coverage-item-row-two.js